import { useLocation, useNavigate } from "react-router-dom";
import { Home, Sparkles, Shirt, Activity, User } from "lucide-react";

// Nova bottom navigation — 5 tabs (master spec):
// Home · Improve · Style · Progress · Profile
// "Improve" hubs Fitness/Nutrition/Skincare/Fragrance/Coach into one place.
// "Style" is the screenshot-analyzer + shopping finder (Rate My Outfit).

const TABS = [
  { id: "home",     label: "Home",     icon: Home,     path: "/home",     match: (p) => p === "/home" },
  { id: "improve",  label: "Improve",  icon: Sparkles, path: "/improve",  match: (p) => p.startsWith("/improve") || p.startsWith("/nutrition") || p.startsWith("/coach") || p.startsWith("/glow-up") },
  { id: "style",    label: "Style",    icon: Shirt,    path: "/style",    match: (p) => p === "/style" || p.startsWith("/rate") || p.startsWith("/upload") || p.startsWith("/stylist") || p.startsWith("/celebrity") || p.startsWith("/saved") },
  { id: "progress", label: "Progress", icon: Activity, path: "/progress", match: (p) => p.startsWith("/progress") || p.startsWith("/trends") },
  { id: "profile",  label: "Profile",  icon: User,     path: "/profile",  match: (p) => p === "/profile" || p === "/settings" || p === "/premium" || p === "/profile-setup" },
];

export default function BottomNav() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  return (
    <nav className="glow-nav" data-testid="glow-bottom-nav" aria-label="Primary">
      {TABS.map((t) => {
        const Icon = t.icon;
        const active = t.match(pathname);
        return (
          <button
            key={t.id}
            type="button"
            className={`glow-nav-item ${active ? "active" : ""}`}
            onClick={() => navigate(t.path)}
            aria-current={active ? "page" : undefined}
            data-testid={`glow-nav-${t.id}`}
          >
            <Icon size={20} strokeWidth={1.6} />
            {active && <span className="glow-nav-label">{t.label}</span>}
          </button>
        );
      })}
    </nav>
  );
}
